import { jsx as _jsx } from "react/jsx-runtime";
/**
 * FormInput icon component for the Form Input action type in selectors and lists.
 */
import { FormInput } from "lucide-react";
/**
 * Icon component for the form input step type.
 * @param root0 - The component props
 * @param root0.className - CSS class name for styling
 * @returns The FormInput icon from lucide-react
 */
export function Icon({ className }) {
    return _jsx(FormInput, { className: className });
}
//# sourceMappingURL=Icon.js.map